/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateSceneRequestBody
 */
export interface UpdateSceneRequestBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateSceneRequestBody
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSceneRequestBody
     */
    note?: string;
}

export function UpdateSceneRequestBodyFromJSON(json: any): UpdateSceneRequestBody {
    return UpdateSceneRequestBodyFromJSONTyped(json, false);
}

export function UpdateSceneRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSceneRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'label': !exists(json, 'label') ? undefined : json['label'],
        'note': !exists(json, 'note') ? undefined : json['note'],
    };
}

export function UpdateSceneRequestBodyToJSON(value?: UpdateSceneRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'label': value.label,
        'note': value.note,
    };
}

